import { Box, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { FC } from "react";
import LoadingButton from "@mui/lab/LoadingButton";

interface SelectViewProps {
	data: any;
	loading: boolean;
	selectedView: string;
	setSelectedView: (index: string) => void;
	changeTab: (
		index: number,
	) => void;
}

const SelectView: FC<SelectViewProps> = ({
	data,
	loading,
	selectedView,
	setSelectedView,
	changeTab
}: SelectViewProps) => {
    //Handle Region Select
    const handleViewSelect = (e: any) => {
			setSelectedView(e.target.value);
    };

    const submitOnClick = async () => {
			changeTab(1);
    };

  return (
		<Grid
			container
			sx={{ pb: 2, pt: 2, pl: 2 }}
			spacing={2}
			alignItems="stretch"
			flexDirection={"column"}
		>			
			<Grid item xs md={12}>
				<Typography
					component={"span"}
					variant="h6"
					color="text.primary"
					sx={{ mb: 1.5 }}
					paragraph
				>
					Select a Resource Explorer User View in your AWS Account.
				</Typography>
			</Grid>
			<Grid item md={6}>
				<Box sx={{ minWidth: 120 }}>
					<FormControl fullWidth>
						<InputLabel id="resource-explorer-view">
							View
						</InputLabel>
						<Select
							required
							id="resource-explorer-view--select"
							name="view"
							value={selectedView}
							label="View"
							onChange={handleViewSelect}
						>	
							{selectedView === "loading" && (
								<MenuItem value="loading" disabled>
									Loading...
								</MenuItem>
							)}
							{data?.items?.map((a: any) => {
								return (
									<MenuItem
										key={a.ViewArn}
										value={a.ViewArn}
									>{`${a.Name}`}</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Box>
			</Grid>
			<Grid item md={6}></Grid>
			<Grid item xs md={4} justifyContent="flex-end">
				<LoadingButton
					id="wat-setup-btn"
					variant="contained"
					color="secondary"
					type="submit"
					disabled={data?.items === null}
					loading={loading}
					onClick={() => 
							submitOnClick()
					}
					sx={{
							width: 257,
							height: 40,
							bgcolor: "secondary.main",
							"&:hover": {
									bgcolor: "secondary.main",
									color: "secondary.contrastText",
							},
					}}
					loadingIndicator={
							<CircularProgress color={"secondary"} size={22} />
					}
				>
					Explore Resources
				</LoadingButton>
			</Grid>
		</Grid>
  )
};

export default SelectView;